jQuery(document).ready(function ($) {
    const meet_the_team_carousel = new Swiper('.meet-the-team__carousel', {
        loop: true,

        slidesPerView: 1,

        spaceBetween: 24,

        grabCursor: true,

        pagination: {
            el: '.meet-the-team__carousel--pagination',
            type: 'bullets',
            bulletClass: 'pagination__bullet',
            bulletActiveClass: 'active',
            clickable: true
        },

        autoplay: true,
        delay: 8000,
        speed: 500,
    });
});